import { render, staticRenderFns } from "./button.vue?vue&type=template&id=155c54a0&scoped=true&lang=pug&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"
import style0 from "./button.vue?vue&type=style&index=0&id=155c54a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c54a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('155c54a0', component.options)
    } else {
      api.reload('155c54a0', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=155c54a0&scoped=true&lang=pug&", function () {
      api.rerender('155c54a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/button.vue"
export default component.exports